import React from 'react';
import { safeRender } from '../utils/displayUtils';

const AnalysisProgressDisplay = ({
  progress,
  processingStage,
  stageDetails,
  estimatedTimeLeft,
  elapsedTime,
  processingSpeed,
  currentItem,
}) => {
  return (
    <div className="card-section">
      <div className="section-content">
        <div>
          <div className="progress-container">
            <div
              className="progress-bar"
              style={{ width: `${progress}%` }}
            >
              <div className="progress-shimmer"></div>
            </div>
          </div>
        </div>

        <div className="flex justify-between text-sm text-gray-500 mb-4 mt-3">
          <div className="flex flex-col items-start w-1/3">
            <span className={`flex items-center mb-1 ${processingStage === 'resolving_groups' ? 'text-indigo-600 font-semibold' : ''}`}>
              {processingStage === 'resolving_groups' && (
                <span className="inline-block w-2 h-2 rounded-full bg-indigo-600 mr-1" style={{ animation: 'pulse 1.5s infinite' }}></span>
              )}
              Получение групп
            </span>
          </div>
          <div className="flex flex-col items-center w-1/3">
            <span className={`flex items-center mb-1 ${processingStage === 'fetching_posts' ? 'text-indigo-600 font-semibold' : ''}`}>
              {processingStage === 'fetching_posts' && (
                <span className="inline-block w-2 h-2 rounded-full bg-indigo-600 mr-1" style={{ animation: 'pulse 1.5s infinite' }}></span>
              )}
              Получение постов
            </span>
          </div>
          <div className="flex flex-col items-end w-1/3">
            <span className={`flex items-center mb-1 ${processingStage === 'processing_data' ? 'text-indigo-600 font-semibold' : ''}`}>
              {processingStage === 'processing_data' && (
                <span className="inline-block w-2 h-2 rounded-full bg-indigo-600 mr-1" style={{ animation: 'pulse 1.5s infinite' }}></span>
              )}
              Анализ данных
            </span>
          </div>
        </div>

        {processingStage && (
          <div className="grid-2 mt-4">
            <div className="stat-card">
              <span className="stat-label">Прогресс:</span>
              <span className="stat-value">
                <strong>{stageDetails.processed}</strong> из <strong>{stageDetails.total}</strong>
                <span className="text-xs text-gray-500 ml-1">
                  ({Math.round((stageDetails.processed / Math.max(stageDetails.total, 1)) * 100)}%)
                </span>
              </span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Осталось времени:</span>
              <span className="stat-value-primary">
                {safeRender(estimatedTimeLeft, 'расчет...', true)}
              </span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Прошло времени:</span>
              <span className="stat-value">
                {safeRender(elapsedTime, '0 сек', true)}
              </span>
            </div>
            <div className="stat-card">
              <span className="stat-label">Скорость обработки:</span>
              <span className="stat-value">
                {safeRender(processingSpeed, 'расчет...', false)}
              </span>
            </div>
          </div>
        )}

        {currentItem && (
          <div className="flex items-start mt-4 p-3 bg-blue-50 rounded border border-blue-200 text-sm overflow-hidden">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 mt-0.5 flex-shrink-0">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <div>
              <span className="block font-medium text-blue-700 mb-0.5">Текущий элемент:</span>
              <span className="block text-blue-900 break-words">{safeRender(currentItem, 'Загрузка...', false)}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalysisProgressDisplay; 